import { Box, Card, Checkbox, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { memo, ReactNode } from 'react';
import { MUIAvatar } from '../../../components/Avatar/MUIAvatar';

interface CheckboxListItemProps<T> {
  avatarUrl?: string;
  checked: boolean;
  data: T;
  id: string | number;
  onAdd?: () => void;
  onCardClick: (data: T) => void;
  onCheckboxChange: (data: T) => void;
  onRemove?: () => void;
  primary: string;
  removeTitle?: string;
  secondary: string | ReactNode;
  selected: boolean;
  showActions?: boolean;
}

function CheckboxListItemImpl<T>({
  avatarUrl = '',
  checked,
  data,
  id,
  onCardClick,
  onCheckboxChange,
  primary,
  secondary,
  selected,
}: CheckboxListItemProps<T>) {
  return (
    <Box key={id} sx={{ display: 'flex', alignItems: 'center', mb: '.25rem' }}>
      <Checkbox checked={checked} color={'primary'} onChange={() => onCheckboxChange(data)} />
      <ListItem disablePadding>
        <Card sx={{ flex: 1 }} variant='outlined'>
          <ListItemButton selected={selected} onClick={() => onCardClick(data)}>
            <ListItemAvatar sx={{ minWidth: '2.25rem' }}>
              <MUIAvatar nameParts={primary.split(' ')} src={avatarUrl} />
            </ListItemAvatar>
            <ListItemText primary={primary} />
            <ListItemText primary={secondary} sx={{ color: 'text.secondary', textAlign: 'right' }} />
          </ListItemButton>
        </Card>
      </ListItem>
    </Box>
  );
}

export const CheckboxListItem = memo(CheckboxListItemImpl) as typeof CheckboxListItemImpl;
